import React, { useState } from 'react'
import { Label, Input } from "abs-ui-components";
import { Typography } from '@mui/material';
import RestoreIcon from '@mui/icons-material/Restore';

const FuelRegistryInput = ({

  label,
  name,
  bold = true,
  required,
  disabled,
  value,
  onChange,
  error,
  metaKey,
  handleMetaChange,
  isOverWritten = false,
  onRestore,
  style = {},
  className = "mb-1",
  colProps = { md: "3" },
  noGutters = true,
  categoryType,
  ...inputProps
}) => {
  const ALPHA_ALLOWED_FIELDS = ["BDN|ID", "POS|ID", "fuelName"];
  var allowNegative = ["e-Fuel", "Biofuel"].includes(categoryType) && name.toLowerCase() === "E|VALUE|GCO2EQ|MJ".toLowerCase();
  const handleChange = (e) => {
    let value = e;

    if (!ALPHA_ALLOWED_FIELDS.includes(name)) {
      if (allowNegative) {

        value = value.replace(/[^0-9.-]/g, "");

        if (value.includes("-")) {
          value = value.replace(/(?!^)-/g, "");
        }
      } else {

        value = value.replace(/[^0-9.]/g, "");
      }
      const dotCount = (value.match(/\./g) || []).length;
      if (dotCount > 1) {
        const firstDotIndex = value.indexOf(".");
        value =
          value.substring(0, firstDotIndex + 1) +
          value.substring(firstDotIndex + 1).replace(/\./g, "");
      }
    }

    if (metaKey && handleMetaChange) {
      handleMetaChange(value, metaKey);
    } else if (onChange) {
      onChange(value);
    }
  };

  return (
    <div className={noGutters ? "no-gutters" : ""} style={{ width: "100%" }}>
      {/* Label + Restore Icon in a row */}
      <div style={{ display: "flex", alignItems: "center", marginBottom: "4px" }}>
        <Label
          bold={bold}
          name={label}
          required={required}
          className={className}
        />
        {isOverWritten && onRestore && value  && (
          <RestoreIcon
            onClick={onRestore}
            title="Restore original value"
            fontSize='small'
            sx={{ fontSize: '16px', cursor: 'pointer', marginLeft: '2px', marginBottom: "6px" }}
          />

        )}
      </div>

      <Input
        disabled={disabled}
        autoFocus={false}
        value={value}
        onChange={handleChange}
        style={{
          paddingTop: "10px",
          paddingBottom: "10px",
          //backgroundColor: isOverWritten ? "#fff9c4" : undefined,
          fontWeight: isOverWritten ? "bold" : undefined,
          ...style
        }}
        {...inputProps}
      />

      {error && (
        <Typography style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px" }}>
          {label ? `${label} is required` : `${name} is required`}
        </Typography>
      )}

    </div>

  )
}

export default FuelRegistryInput
